import type { PersistedPin } from '../types.js';

export function getReviewerNameKey(projectId: string) {
  return `bs_reviewer_name_${projectId}`;
}

export function getReviewerEmailKey(projectId: string) {
  return `bs_reviewer_email_${projectId}`;
}

export function getReviewerName(projectId: string) {
  return localStorage.getItem(getReviewerNameKey(projectId));
}

export function setReviewerName(projectId: string, name: string) {
  localStorage.setItem(getReviewerNameKey(projectId), name);
}

export function getReviewerEmail(projectId: string) {
  return localStorage.getItem(getReviewerEmailKey(projectId));
}

export function buildSelectorPath(el: Element): string {
  const parts: string[] = [];
  let current: Element | null = el;

  while (current && current !== document.body && current !== document.documentElement) {
    let segment = current.tagName.toLowerCase();
    if (current.id) {
      parts.unshift(`${segment}#${current.id}`);
      break;
    }

    const parent = current.parentElement;
    if (parent) {
      const siblings = Array.from(parent.children).filter((child) => child.tagName === current?.tagName);
      if (siblings.length > 1) {
        segment += `:nth-of-type(${siblings.indexOf(current) + 1})`;
      }
    }

    parts.unshift(segment);
    current = current.parentElement;
  }

  return parts.join(' > ') || el.tagName.toLowerCase();
}

export function loadPersistedPins(projectId: string, pathname: string): PersistedPin[] {
  try {
    return JSON.parse(localStorage.getItem(getPinsStorageKey(projectId, pathname)) ?? '[]') as PersistedPin[];
  } catch {
    return [];
  }
}

export function savePersistedPin(projectId: string, pathname: string, pin: PersistedPin) {
  const stored = loadPersistedPins(projectId, pathname);
  stored.push(pin);
  localStorage.setItem(getPinsStorageKey(projectId, pathname), JSON.stringify(stored));
}

export function replacePersistedPins(projectId: string, pathname: string, pins: PersistedPin[]) {
  localStorage.setItem(getPinsStorageKey(projectId, pathname), JSON.stringify(pins));
}

function getPinsStorageKey(projectId: string, pathname: string) {
  return `bs_pins_${projectId}_${pathname}`;
}
